export default {
  getUserPermissions: (state) => state.permissions,
}
